"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * session-manager-lambda openapi
 * API gateway for session-manager-lambda
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionCreateTransportEncodingTypeEnum = exports.SessionCreateDrmTypeEnum = exports.SessionCreateDeviceTypeEnum = void 0;
exports.SessionCreateDeviceTypeEnum = {
    AndroidPhone: 'androidPhone',
    AndroidTablet: 'androidTablet',
    AndroidTv: 'androidTv',
    AndroidTvSony: 'androidTvSony',
    AppleTv: 'appleTv',
    FireDevice: 'fireDevice',
    FirePhone: 'firePhone',
    FireTablet: 'fireTablet',
    FireTv: 'fireTv',
    IPad: 'iPad',
    IPhone: 'iPhone',
    IptvSmartTv: 'iptvSmartTv',
    ManagedAndroidTv: 'managedAndroidTv',
    ManagedCubiTv: 'managedCubiTv',
    Roku: 'roku',
    RokuTv: 'rokuTv',
    Stb: 'stb',
    WebPlayer: 'webPlayer',
    WebPlayerChrome: 'webPlayerChrome',
    WebPlayerMicrosoft: 'webPlayerMicrosoft',
    WebPlayerSafari: 'webPlayerSafari'
};
exports.SessionCreateDrmTypeEnum = {
    Clear: 'clear',
    FairPlay: 'fairPlay',
    Kaltura: 'kaltura',
    PlayReady: 'playReady',
    Tivo: 'tivo',
    Verimatrix: 'verimatrix',
    Widevine: 'widevine',
    WindowsMedia: 'windowsMedia'
};
exports.SessionCreateTransportEncodingTypeEnum = {
    DashFmp4TransportStream: 'dashFmp4TransportStream',
    DashTransportStream: 'dashTransportStream',
    HlsFmp4TransportStream: 'hlsFmp4TransportStream',
    HlsTransportStream: 'hlsTransportStream',
    Mpeg2TransportStream: 'mpeg2TransportStream',
    SmoothTransportStream: 'smoothTransportStream',
    Unknown: 'unknown'
};
